import type { TenantConfig } from "../types/tenantConfig";

/**
 * Does the tenant's login hand us the customer's name and e-mail, so the
 * booking flow takes them from there instead of asking? Only EntraID does: its
 * ID token carries them (`getEmailAndFirstAndLastName`, Authorizer.ts).
 *
 * The ONE answer for the storage flow's step list, its step counter and its
 * summary prefill. The step list used to ask "is there any login?" while the
 * other two asked "is it EntraID?" — identical today, but a third login type
 * would have dropped the step without anything filling the data in.
 */
export const loginSuppliesContactData = (
  authentication: TenantConfig["authentication"] | undefined
): boolean => authentication === "entraid";
